import TFormInput from './FormInput.vue'

export const FormInput = TFormInput
